import React from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

import Tutorial from "../../../../Tutorial";
import { IProps } from "./interfaces";
import messages from "./messages";

const RhythmTutorial = ({ close, title }: IProps) => (
    <Tutorial close={close} title={title}>
        {[
            {
                title: <FormattedMessage {...messages.title1} />,
                content: <FormattedHTMLMessage {...messages.description1} />,
            },
            {
                title: <FormattedMessage {...messages.title3} />,
                content: <FormattedHTMLMessage {...messages.description3} />,
            },
            {
                title: <FormattedMessage {...messages.title4} />,
                content: <FormattedHTMLMessage {...messages.description4} />,
            },
        ]}
    </Tutorial>
);

export default RhythmTutorial;
